<h4 mat-dialog-title>
  <span *ngIf="!data?.id;else editHeader">
    Creazione nuovo template
  </span>
  <ng-template #editHeader>
    Modifica template {{data.nome}}
  </ng-template>
</h4>
<form *ngIf="form" [formGroup]="form" class="mt-4" (keydown.enter)="edit()">
  <div>
    <mat-form-field>
      <mat-label>Nome</mat-label>
      <input matInput formControlName="nome">
      <mat-icon matSuffix>nome</mat-icon>
    </mat-form-field>
  </div>
  <div>
    <mat-form-field>
      <mat-label>Descrizione</mat-label>
      <input matInput formControlName="descrizione">
      <mat-icon matSuffix>descrizione</mat-icon>
    </mat-form-field>
  </div>
  <div>
    <mat-form-field>
      <mat-label>Tipo template</mat-label>
      <tipo-template-picker formControlName="tipo_template"></tipo-template-picker>
    </mat-form-field>
  </div>
  <div>
    <mat-form-field>
      <mat-label>Eventuale stato incarico automatizzato</mat-label>
      <stato-incarico-picker formControlName="stato_incarico"></stato-incarico-picker>
    </mat-form-field>
  </div>
  <div>
    <mat-form-field>
      <mat-label>File .docx o .xlsx o .xls template</mat-label>
      <ngx-mat-file-input formControlName="file" accept=".xlsx,.xls,.docx"></ngx-mat-file-input>
      <mat-icon matSuffix>folder</mat-icon>
    </mat-form-field>
  </div>
  <div>
    <mat-form-field>
      <mat-label>Questo template è per la compagnia:</mat-label>
      <compagnia-picker formControlName="compagnia">
      </compagnia-picker>
    </mat-form-field>
  </div>
  <div>
    <mat-form-field>
      <mat-label>Questo template è per lo studio:</mat-label>
      <studio-picker formControlName="studio">
      </studio-picker>
    </mat-form-field>
  </div>
  <div>
    <mat-form-field>
      <mat-label>Ossatura</mat-label>
      <input matInput formControlName="doc_default_text">
    </mat-form-field>
  </div>
</form>
<button mat-raised-button (click)="edit()" color="primary">Salva</button>